import imagePlaceholder from '@/assets/placeholder.png';
import Modal from '@/components/Modal';
import Constants from '@/Constants';
import { Program } from '@/models/Program';
import { courseService } from '@/services/CourseService';
import { ApplicationState } from '@/store';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import './style.scss';

interface ProgramCardProps {
    program: Program;
}

const ProgramCard = ({ program }: ProgramCardProps) => {
    const [icon, setIcon] = useState('');
    const [alertText, setAlertText] = useState('');
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    const { data: identity } = useSelector((state: ApplicationState) => state.identity);

    const { id, status } = program;

    const handleModalChange = (icon: string, text: string) => {
        setIcon(icon);
        setAlertText(text);
    };

    const renderActions = () => {
        switch (status) {
            case 'PUBLISHED':
                return (
                    <Link className="dropdown-content" to={`/contents/lms/programs/${id}`}>
                        <i className="material-icons va-t m-right--xxs">{Constants.icons.EDIT}</i>
                        <span>{strings.EDIT}</span>
                    </Link>
                );
            case 'DRAFT':
                return (
                    <>
                        <Link className="dropdown-content" to={`/contents/lms/programs/${id}`}>
                            <i className="material-icons va-t m-right--xxs">{Constants.icons.EDIT}</i>
                            <span>{strings.EDIT}</span>
                        </Link>
                        {/* Comentado para pŕoxima implementação
                        <div
                            className="dropdown-content"
                            data-target={`#alert-modal-${id}`}
                            data-toggle="modal"
                            onClick={() => handleModalChange('delete', strings.DELETE_COURSE_CONFIRMATION, 'delete')}
                            onKeyDown={() => {}}
                            role="button"
                            tabIndex={0}
                        >

                            <i className="material-icons-outlined va-t m-right--xxs">{Constants.icons.DELETE}</i>
                            <span>{strings.REMOVE}</span>
                        </div> */}
                    </>
                );
            case 'ARCHIVED':
                return (
                    <div
                        className="dropdown-content"
                        data-target={`#alert-modal-${id}`}
                        data-toggle="modal"
                        onClick={() => handleModalChange('undo', strings.UNARCHIVE_LIST_CONFIRMATION)}
                        onKeyDown={() => {}}
                        role="button"
                        tabIndex={0}
                    >
                        <i className="material-icons-outlined va-t m-right--xxs">{Constants.icons.UNDO}</i>
                        <span>{strings.UNARCHIVE}</span>
                    </div>
                );
            default:
                return null;
        }
    };

    const formatCreatedOn = (value?: Date) => {
        const locales = strings._LANGUAGE === 'pt' ? 'pt-BR' : 'en-US';
        if (!value) return value;
        const data = new Date(value);
        return data.toLocaleDateString(locales);
    };

    return (
        <>
            <Modal content={alertText} icon={icon} leftButtonText={strings.YES} rightButtonText={strings.NO} target={`alert-modal-${id}`} />
            <div className="program-card-list-list">
                <div className="content-top">
                    <img alt="" src={program.mainImage || imagePlaceholder} />
                    {(program.organizationId !== null || identity.user.admin) && (
                        <div className="dropdown">
                            <i className="material-icons-outlined align-middle more" data-toggle="dropdown">
                                {Constants.icons.MORE_HORIZ}
                            </i>
                            <div className="dropdown-menu dropdown-menu-right">
                                <div className="triangle-container">
                                    <div className="dropdown-triangle" />
                                    <div className="dropdown-triangle-border" />
                                </div>
                                {renderActions()}
                            </div>
                        </div>
                    )}
                </div>

                <div className="mt-3 d-flex flex-row w-100">
                    <span className="program-type">{strings.PROGRAM}</span>
                    <span className="ml-auto rate">
                        <i className="material-icons">{Constants.icons.STAR}</i>
                        {0.0}
                    </span>
                </div>

                <div className="program-card-content">
                    <span className="program-title" title={program.name}>
                        {program.name}
                    </span>
                    <span className="program-info-key">
                        {strings.AUTHOR}: <span className="program-info-value" title={program.author}>{program.author}</span>
                    </span>
                    <span className="program-info-key">
                        {strings.LANGUAGE}: <span className="program-info-value">{courseService.getLanguageRendering(program.locale, strings)}</span>
                    </span>
                    <span className="program-info-key">
                        {strings.CREATED_AT_PROGRAM}: <span className="program-info-value">{formatCreatedOn(program.createdOn) || '--/--'}</span>
                    </span>
                    <span className="program-info-key">
                        {strings.DURATION}: <span className="program-info-value">{`${program.workload || 0} min`}</span>
                    </span>

                    <span className="program-info-key">
                        {strings.CLASSES}: <span className="program-info-value">{program.classAmount || 0}</span>
                    </span>
                </div>

                <div className="program-actions">
                    <div className="program-counters">
                        {!!program.courseAmount && program.courseAmount > 0 && (
                            <span className="program-count">
                                {program.courseAmount}
                                <span>{program.courseAmount !== 1 ? ` ${strings.COURSES}` : ` ${strings.COURSE}`}</span>
                            </span>
                        )}

                        {!!program.workshopAmount && program.workshopAmount > 0 && (
                            <span className="program-count">
                                {program.workshopAmount}
                                <span>{program.workshopAmount !== 1 ? ` ${strings.WORKSHOPS}` : ` ${strings.WORKSHOP}`}</span>
                            </span>
                        )}
                    </div>

                    <div className="program-action-button">
                        {program.status === 'PUBLISHED' && (identity.user.admin || identity.person.dynamicAttributes?.selectedProfile === 'HR') && (
                            <Link className="btn btn-light btn-sm" to={`/contents/lms/programs/${id}/classes`}>
                                {strings.MANAGE_CLASSES}
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
export default ProgramCard;
